import { z } from 'zod';
import { SourceSystem, VarianceReason } from '../enums.js';
import { DecimalString, IsoDateTime, MoneyAmount, UuidString } from '../primitives.js';

/**
 * Stock Reconciliation document.
 * Type 'opening_stock' — единственный документ, чей SLE может быть раньше onboarding date.
 */
export const StockReconciliationType = z.enum(['opening_stock', 'physical_count']);
export type StockReconciliationType = z.infer<typeof StockReconciliationType>;

export const StockReconciliation = z.object({
  id: UuidString,
  entity_id: UuidString,
  voucher_no: z.string().min(1),
  reconciliation_type: StockReconciliationType,
  posting_datetime: IsoDateTime,
  warehouse_id: UuidString.nullable(),
  remarks: z.string().nullable(),
  is_submitted: z.boolean().default(false),
  is_cancelled: z.boolean().default(false),
  source_system: SourceSystem.default('staiter'),
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type StockReconciliation = z.infer<typeof StockReconciliation>;

export const StockReconciliationItem = z.object({
  id: UuidString,
  entity_id: UuidString,
  reconciliation_id: UuidString,
  position: z.number().int().nonnegative(),
  item_id: UuidString,
  warehouse_id: UuidString,
  batch_id: UuidString.nullable(),
  expected_qty: DecimalString,
  counted_qty: DecimalString,
  variance_qty: DecimalString,
  variance_value: MoneyAmount,
  variance_reason: VarianceReason.nullable(),
  valuation_rate: MoneyAmount,
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type StockReconciliationItem = z.infer<typeof StockReconciliationItem>;
